// Centralised retailer configuration for Sip Alchemy.
// Add verified retailer partners here in the future. Keep the map empty when
// no confirmed retailer is configured — the UI will fall back to editorial
// details CTAs and NEVER redirect users to a broken or unverified store.
//
// Shape:
//   RETAILERS[key] = {
//     name: "Retailer name",
//     buildUrl: (item) => "https://..."  // must be a verified live URL builder
//   }
//
// Legal note: alcohol e-commerce is state/UT-regulated in India. Only enable
// a retailer here after confirming they operate in the user's state and the
// destination URL responds.

export const RETAILERS = {};

// Public helpers -------------------------------------------------------------

export function hasRetailers() {
  return Object.keys(RETAILERS).length > 0;
}

export function getPrimaryRetailer() {
  const keys = Object.keys(RETAILERS);
  return keys.length ? RETAILERS[keys[0]] : null;
}

// Returns a safe URL string, or null if no retailer is configured.
export function getRetailerUrl(item) {
  const r = getPrimaryRetailer();
  if (!r || typeof r.buildUrl !== "function") return null;
  try {
    const url = r.buildUrl(item);
    if (!url || typeof url !== "string") return null;
    return url;
  } catch {
    return null;
  }
}
